import { render, staticRenderFns } from "./admin-order-details.vue?vue&type=template&id=16b533d0"
import script from "./admin-order-details.vue?vue&type=script&lang=ts"
export * from "./admin-order-details.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16b533d0')) {
      api.createRecord('16b533d0', component.options)
    } else {
      api.reload('16b533d0', component.options)
    }
    module.hot.accept("./admin-order-details.vue?vue&type=template&id=16b533d0", function () {
      api.rerender('16b533d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "admin-components/admin-order-details.vue"
export default component.exports